import { call, select, put, all, takeLatest } from "redux-saga/effects";
import {
  selectArriveLateDetailId,
  selectFormReqArrivingLateLeaveEarly,
} from "../redux/selector";
import { checkIsExitsReqArriveLateApi } from "core/http/service/timeKeeping";
import {
  checkIsExitsReqArriveLateFailed,
  checkIsExitsReqArriveLateStart,
  checkIsExitsReqArriveLateSuccess,
} from "../redux/checkIsExitsReqArriveLate";
import { toast } from "react-toastify";

function* checkIsExitsReqArriveLateWork(action) {
  const screenCode = action.payload;
  const { longTerm } = yield select(selectFormReqArrivingLateLeaveEarly);
  const id = yield select(selectArriveLateDetailId);

  try {
    const newFormData = {
      id: id || undefined,
      fromDate: longTerm?.fromDate?.toISOString(),
      toDate: longTerm?.toDate?.toISOString(),
      type: longTerm?.typeReq,
    };
    const res = yield call(
      checkIsExitsReqArriveLateApi,
      newFormData,
      screenCode
    );
    if (res) {
      yield put({
        type: checkIsExitsReqArriveLateSuccess.type,
      });
      //   toast.success("Cập nhật đơn thành công!");
    }
  } catch (err: any) {
    yield put({
      type: checkIsExitsReqArriveLateFailed.type,
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchCreateReqArriveLate() {
  yield takeLatest(
    checkIsExitsReqArriveLateStart.type,
    checkIsExitsReqArriveLateWork
  );
}

export default function* checkIsExitsReqArriveLateSaga() {
  yield all([watchCreateReqArriveLate()]);
}
